import CITY_MUTATION_TYPES from './city.mutation-types';

const CITY_MUTATIONS = {
  [CITY_MUTATION_TYPES.SET_ERROR](state, error) {
    state.status.error = error;
  },
  [CITY_MUTATION_TYPES.APPEND_CITIES](state, cities) {
    state.cities = cities;
  },
};

export default CITY_MUTATIONS;
